import { FixedSection } from '@/sections/types/sections.types';
import {IParamsCreateComponent} from '@/courses/interfaces/params-create-component.interface';

export class Section {

  classId?: number;
  courseId?: number;
  sectionId?: number;
  parentId?: number;
  name: string;
  assetsInfo?: any;
  text?: any;
  type: string;
  sections?: any[];
  description?: string;
  hasBeenResolvedByAnyStudent?: boolean;
  homework?: boolean;
  homeworkId?: number;
  homeworkStatus?: string;
  homeworkInfo?: any;
  homeworkFeedbackInfo?: any;
  homeworkAssetInfo?: any;
  homeworkGrade?: number;
  gradeName?: string;
  gradingDetails?: any;
  template?: any;
  resolved?: boolean;
  sectionMaterial?: any;
  status?: string;
  teacherOnly?: boolean;
  studentId?: number;
  submissionDates?: SectionSubmissionDates;
  autoGeneratedName?: boolean;
  loading?: boolean;
  homeworkPoints?: number;
  homeworkWeight?: number;
  section?: any;
  id?: number;
  fixedSection?: FixedSection = null;
  fixedSequence?: number = null;
  labelSections: string;
  component?: IParamsCreateComponent;
  order?: number = 0;
  lessonDuration?: number;
  archiveCurrentHomeworks?: boolean;
  version?: number;

  constructor(data: any) {
    Object.assign(this, data);
    this.classId = data.classId ? data.classId : null;
    this.sectionId = data.id ? data.id : data.sectionId;
    this.resolved = data.hasBeenResolvedByAnyStudent;
  }
}

export class SectionSubmissionDates {
  dueDate?: string;
  dueSchoolDay?: number;
  startDate?: string;
  startSchoolDay?: number;
  lastDate?: string;
  lastSchoolDay?: number;
  dueDateAuto?: boolean;
  lastDateAuto?: boolean;
}